export const Roles = {
  CITY_ADMIN: 'city_admin',
  PARTNER: 'partner',
  USER: 'user',
  ADVISOR: 'advisor',
  SUPER_ADMIN: 'super_admin',
};
